import { getRandomInt } from '@/modules/utils';

export const parseActionFromText = result => {
  try {
    const url = new URL(result);
    const { hostname, pathname, search } = url;
    if (!hostname.endsWith('tg3ds.com') && !hostname.endsWith('tg3ds.com.cn')) return {};

    if (pathname.startsWith('/share/') && pathname.endsWith('/garment-display')) {
      return {
        type: 'garment',
        payload: result,
      };
    }
    if (pathname.endsWith('/links')) {
      const params = new URLSearchParams(search);
      const dataCount = parseInt(params.get('dc'), 10) || 0;
      const type = params.get('at');
      if (!type || !dataCount) return {};

      const payload = [];
      for (let i = 0; i < dataCount; i += 1) {
        payload.push(params.get(`d${i}`));
      }
      return {
        type,
        payload: payload.length === 1 ? payload[0] : payload,
      };
    }
    return {};
  } catch (e) {
    const prefix = result.split(':', 2);
    if (!Array.isArray(prefix)) return {};

    if (prefix[0] === '_tg3ds') {
      return {
        type: prefix[1],
        payload: result.replace(`${prefix[0]}:${prefix[1]}:`, ''),
      };
    }

    return {};
  }
};

const determineCharPosition = base => (base[0].charCodeAt(0) % 9) + 1;

export const makeEncodedStoreId = storeId => {
  const extra = getRandomInt(0, 10);
  const base = window.btoa(storeId).split('');
  const charPosition = determineCharPosition(base);
  base.splice(charPosition, 0, extra);
  return base.join('');
};

export const decodeStoreId = encoded => {
  const base = encoded.split('');
  const charPosition = determineCharPosition(base);
  base.splice(charPosition, 1);
  return window.atob(base.join(''));
};

/**
 * Decode an encoded store id payload, returning '' when it isn't a usable one,
 * so callers never have to guard against atob / charCodeAt throwing.
 */
export const parseStoreId = encoded => {
  try {
    if (typeof encoded !== 'string' || !encoded) return '';

    return decodeStoreId(encoded) || '';
  } catch (e) {
    console.log(`[qr-action] failed to decode store id: ${e.message}`);
    return '';
  }
};

/**
 * Turn a store QR payload into what starting a mobile scan needs: the store id
 * and the single use qr_token from `d1`. Both are mandatory.
 *
 * QR codes printed before the token existed only carry `d0`. Those used to fall
 * back to the store's session key, but a mobile scan is now authorised by the
 * token alone, so they are rejected here -- one gate for every entry point, and
 * the callers already show the "ask the store for a new QR code" card.
 * Returns null when either part is missing.
 */
export const parseStoreScan = payload => {
  const [encoded, qrToken] = Array.isArray(payload) ? payload : [payload];
  const storeId = parseStoreId(encoded);
  if (!storeId || typeof qrToken !== 'string' || !qrToken) return null;

  return { storeId, qrToken };
};

/** Same, starting from the raw QR code text. */
export const parseStoreScanFromText = text => {
  const { type, payload } = parseActionFromText(text);
  if (type !== 'store') return null;

  return parseStoreScan(payload);
};
